import arrayLikeToArray from "./arrayLikeToArray";
export default function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}


//////////////////
// WEBPACK FOOTER
// ../~/css-vendor/~/@babel/runtime/helpers/esm/arrayWithoutHoles.js
// module id = 2579
// module chunks = 121